export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-movie-2-line', description: '院线大片、经典佳片、热门电影一网打尽' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-2-line', description: '热播剧集、全网独播、追剧不停歇' },
  { slug: 'anime', name: '动漫', icon: 'ri-live-line', description: '日漫国漫、热血冒险、治愈日常应有尽有' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门综艺、搞笑娱乐、音乐竞技精彩纷呈' },
];

export const genres = ['动作', '喜剧', '爱情', '科幻', '悬疑', '恐怖', '动画', '纪录片', '战争', '古装', '都市', '奇幻'];